import React, { useState } from 'react';
import { AlertTriangle, X, ShieldAlert, Info } from 'lucide-react';
interface WarningBannerProps {
  message: string;
  dismissible?: boolean;
  variant?: 'warning' | 'danger' | 'info';
}
export function WarningBanner({
  message,
  dismissible = true,
  variant = 'warning'
}: WarningBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  const variants = {
    warning: {
      container: 'bg-gradient-to-r from-amber-50 to-yellow-50 border-amber-200',
      icon: 'text-amber-600',
      text: 'text-amber-900',
      accent: 'bg-amber-100'
    },
    danger: {
      container: 'bg-gradient-to-r from-red-50 to-rose-50 border-red-200',
      icon: 'text-red-600',
      text: 'text-red-900',
      accent: 'bg-red-100'
    },
    info: {
      container: 'bg-gradient-to-r from-blue-50 to-cyan-50 border-blue-200',
      icon: 'text-blue-600',
      text: 'text-blue-900',
      accent: 'bg-blue-100'
    }
  };
  const style = variants[variant];
  const getIcon = () => {
    switch (variant) {
      case 'danger':
        return <ShieldAlert className={`h-5 w-5 ${style.icon}`} data-id="element-277" />;
      case 'info':
        return <Info className={`h-5 w-5 ${style.icon}`} data-id="element-278" />;
      default:
        return <AlertTriangle className={`h-5 w-5 ${style.icon}`} data-id="element-279" />;
    }
  };
  return <div className={`${style.container} border rounded-xl p-4 relative animate-fade-in shadow-sm`} role="alert" data-id="element-280">
      <div className="flex items-center gap-3" data-id="element-281">
        {/* Icon Container */}
        <div className={`flex-shrink-0 ${style.accent} rounded-lg p-2`} data-id="element-282">
          {getIcon()}
        </div>

        {/* Message Content */}
        <div className={`flex-1 ${dismissible ? 'pr-6' : ''}`} data-id="element-283">
          <p className={`text-xs sm:text-sm font-medium leading-relaxed ${style.text}`} data-id="element-284">
            {message}
          </p>
        </div>

        {/* Dismiss Button */}
        {dismissible && <button onClick={() => setIsVisible(false)} className={`absolute top-3 right-3 ${style.icon} hover:opacity-70 transition-opacity rounded-lg p-1 hover:bg-white/50 touch-manipulation`} aria-label="Dismiss warning" data-id="element-285">
            <X className="h-4 w-4" data-id="element-286" />
          </button>}
      </div>
    </div>;
}